module.exports = __webpack_public_path__ + "img/katherine_c.76dd796.png";